import { apiClient } from '@/shared/api/client'
import type { ApiResource } from '@/shared/types/api'

export interface ProjectTransfer {
  id: string
  recipient_email: string
  status: string
  keep_previous_owner?: boolean
  expires_at?: string | null
  created_at?: string
}

export async function getOutgoingTransfer(projectId: string): Promise<ProjectTransfer | null> {
  const response = await apiClient.get<{ data: ProjectTransfer | null }>(
    `/projects/${projectId}/transfers`,
  )
  return response.data.data
}

export async function initiateTransfer(
  projectId: string,
  recipientEmail: string,
  keepPreviousOwner: boolean,
): Promise<ProjectTransfer> {
  const response = await apiClient.post<ApiResource<ProjectTransfer>>(
    `/projects/${projectId}/transfers`,
    { recipient_email: recipientEmail, keep_previous_owner: keepPreviousOwner },
  )
  return response.data.data
}

export async function cancelTransfer(projectId: string, transferId: string): Promise<void> {
  await apiClient.delete(`/projects/${projectId}/transfers/${transferId}`)
}

export interface TransferPreview {
  project_name: string | null
  from_name: string | null
  recipient_email: string
  status: string
  expired: boolean
  keep_previous_owner: boolean
}

export async function getTransferByToken(token: string): Promise<TransferPreview> {
  const response = await apiClient.get<{ data: TransferPreview }>(`/transfers/${token}`)
  return response.data.data
}

export async function acceptTransfer(token: string, organizationId?: string): Promise<void> {
  await apiClient.post(
    `/transfers/${token}/accept`,
    organizationId ? { organization_id: organizationId } : {},
  )
}

export async function declineTransfer(token: string): Promise<void> {
  await apiClient.post(`/transfers/${token}/decline`)
}
